// Reconstructed from the supplied production build; original component names were unavailable.
import {
  ArrowRightIcon,
  CalendarIcon,
  CircleCheckBigIcon,
  CircleHelpIcon,
  ClockIcon,
  CodeIcon,
  DollarSignIcon,
  DownloadIcon,
  EyeIcon,
  FileTextIcon,
  FunnelIcon,
  GlobeIcon,
  ImageIcon,
  InfoIcon,
  PackageIcon,
  React,
  RefreshCwIcon,
  SaveIcon,
  SearchIcon,
  SquarePenIcon,
  TagIcon,
  Trash2Icon,
  UploadIcon,
  UserIcon,
  XIcon,
  jsxRuntime,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
import { SERVER_URL } from "../config.js";
import { ProductAnalysisForm } from "../components/ProductAnalysisForm.jsx";
const ProductsPage = () => {
  const [e, t] = React.useState([]),
    [n, r] = React.useState([]),
    [a, l] = React.useState(true),
    [c, d] = React.useState(null),
    [f, h] = React.useState(""),
    [p, g] = React.useState("all"),
    [y, v] = React.useState("all"),
    [j, N] = React.useState([]),
    [b, S] = React.useState([]),
    [O, _] = React.useState(false),
    [C, A] = React.useState(null),
    [T, M] = React.useState(1),
    [k] = React.useState(10),
    [$, I] = React.useState(false),
    [U, q] = React.useState(null),
    [z, Y] = React.useState({
      title: "",
      category: "",
      amount: "",
      description: "",
      features: "",
      instructions: "",
      faq: "",
      demo: "",
      language: "",
    }),
    [F, B] = React.useState({
      image: null,
      project_file: null,
      report_file: null,
    }),
    [K, Q] = React.useState(false),
    [ne, L] = React.useState(null),
    [ee, re] = React.useState(false),
    [R, W] = React.useState(null);
  (useNavigate(),
    React.useEffect(() => {
      xe();
    }, []),
    React.useEffect(() => {
      ve();
    }, [f, p, y, e]),
    React.useEffect(() => {
      M(1);
    }, [f, p, y]));
  const xe = async () => {
      try {
        l(true);
        const me = await api.get("/admin/products");
        t(me.data);
        const Ue = [...new Set(me.data.map((rt) => rt.category))].filter(Boolean),
          ot = [...new Set(me.data.map((rt) => rt.analysis_status))].filter(Boolean);
        (N(Ue), S(ot));
      } catch (me) {
        (console.error("Error fetching products:", me),
          d("Failed to load products. Please try again later."));
      } finally {
        l(false);
      }
    },
    ve = () => {
      let me = [...e];
      (f &&
        (me = me.filter((Ue) => {
          var ot, rt, wt;
          return (
            ((ot = Ue.title) == null ? undefined : ot.toLowerCase().includes(f.toLowerCase())) ||
            ((rt = Ue.agent_name) == null
              ? undefined
              : rt.toLowerCase().includes(f.toLowerCase())) ||
            ((wt = Ue.description) == null ? undefined : wt.toLowerCase().includes(f.toLowerCase()))
          );
        })),
        p !== "all" && (me = me.filter((Ue) => Ue.category === p)),
        y !== "all" && (me = me.filter((Ue) => Ue.analysis_status === y)),
        r(me));
    },
    te = (me) => {
      (A(me), _(true));
    },
    ye = async () => {
      if (C)
        try {
          (l(true), await api.delete(`/admin/products/${C.id}`), await xe(), _(false), A(null));
        } catch (me) {
          (console.error("Error deleting product:", me),
            d("Failed to delete product. Please try again later."));
        } finally {
          l(false);
        }
    },
    V = (me) => {
      (q(me),
        Y({
          title: me.title || "",
          category: me.category || "",
          amount: me.amount || "",
          description: me.description || "",
          features: me.features || "",
          instructions: me.instructions || "",
          faq: me.faq || "",
          demo: me.demo || "",
          language: me.language || "",
        }),
        B({
          image: null,
          project_file: null,
          report_file: null,
        }),
        I(true));
    },
    de = (me) => {
      (L(me), Q(true));
    },
    oe = (me) => {
      (W(me), re(true));
    },
    ce = (me) => {
      const { name: Ue, value: ot } = me.target;
      Y((rt) => ({
        ...rt,
        [Ue]: ot,
      }));
    },
    $e = async () => {
      var me, Ue;
      if (U)
        try {
          (l(true), d(null));
          const ot = new FormData();
          (Object.keys(z).forEach((wt) => {
            z[wt] !== null && z[wt] !== undefined && ot.append(wt, z[wt]);
          }),
            console.log("Saving product with ID:", U.id),
            console.log("Form data:", z));
          const rt = await api.put(`/admin/products/${U.id}`, ot);
          if ((console.log("Save response:", rt.data), d(null), await xe(), R && R.id === U.id))
            try {
              const wt = await api.get(`/admin/products/${U.id}`);
              W(wt.data);
            } catch (wt) {
              console.error("Error fetching updated product details:", wt);
            }
          (I(false),
            q(null),
            B({
              image: null,
              project_file: null,
              report_file: null,
            }),
            alert("Product updated successfully!"));
        } catch (ot) {
          (console.error("Error updating product:", ot),
            d(
              `Failed to update product: ${((Ue = (me = ot.response) == null ? undefined : me.data) == null ? undefined : Ue.message) || ot.message || "Please try again later."}`,
            ));
        } finally {
          l(false);
        }
    };
  console.log(R);
  const Ae = (me) => {
      const Ue = `${SERVER_URL}/images/${me}`;
      window.open(Ue, "_blank");
    },
    st = (me) =>
      /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/)|youtu\.be\/)[\w-]+/.test(me),
    Ve = (me) => {
      let Ue = "";
      return (
        me.includes("youtube.com/watch?v=")
          ? (Ue = me.split("v=")[1].split("&")[0])
          : me.includes("youtu.be/")
            ? (Ue = me.split("youtu.be/")[1].split("?")[0])
            : me.includes("youtube.com/embed/") && (Ue = me.split("embed/")[1].split("?")[0]),
        `https://www.youtube.com/embed/${Ue}`
      );
    },
    tt = async (me, Ue, ot) => {
      var rt, wt;
      try {
        console.log("Download params:", {
          productId: me,
          fileType: Ue,
          fileName: ot,
        });
        let Zt = "";
        switch (Ue) {
          case "image":
            Zt = `${SERVER_URL}/images/${ot}`;
            break;
          case "project_file":
            Zt = `/admin/download/project/${me}`;
            break;
          case "report_file":
            Zt = `/admin/download/report/${me}`;
            break;
          default:
            throw (
              console.error("Unsupported file type received:", Ue),
              new Error(`Unsupported file type: ${Ue}`)
            );
        }
        console.log("Download URL:", Zt);
        const pi = await api.get(Zt, {
            responseType: "blob",
          }),
          sa = window.URL.createObjectURL(new Blob([pi.data])),
          Ta = document.createElement("a");
        Ta.href = sa;
        const ts = ot || `file_${me}_${Ue}`;
        (Ta.setAttribute("download", ts),
          document.body.appendChild(Ta),
          Ta.click(),
          Ta.remove(),
          window.URL.revokeObjectURL(sa),
          console.log("Download successful for:", ts));
      } catch (Zt) {
        (console.error("Error downloading file:", Zt),
          d(
            `Failed to download file: ${((wt = (rt = Zt.response) == null ? undefined : rt.data) == null ? undefined : wt.message) || Zt.message}. Please try again later.`,
          ));
      }
    },
    _n = (me) => {
      const Ue = e.map((rt) => (rt.id === me.id ? me : rt));
      t(Ue);
      const ot = n.map((rt) => (rt.id === me.id ? me : rt));
      (r(ot), R && R.id === me.id && W(me), Q(false), L(null));
    },
    Bn = () => {
      (h(""), g("all"), v("all"), M(1));
    },
    Xe = Math.ceil(n.length / k),
    $t = (T - 1) * k,
    on = $t + k,
    On = n.slice($t, on),
    ia = (me) => {
      M(me);
    },
    Oa = () => {
      T > 1 && M(T - 1);
    },
    Ur = () => {
      T < Xe && M(T + 1);
    },
    gn = () => {
      const me = [];
      let ot = Math.max(1, T - Math.floor(2.5)),
        rt = Math.min(Xe, ot + 5 - 1);
      rt - ot + 1 < 5 && (ot = Math.max(1, rt - 5 + 1));
      for (let wt = ot; wt <= rt; wt++) me.push(wt);
      return me;
    },
    bt = (me) => (me ? me.split("/").pop() : null),
    Lt = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    };
  return a && e.length === 0 ? (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <div className={"flex items-center justify-center h-screen"}>
        <div className={"p-8 flex flex-col items-center"}>
          <div className={"w-16 h-16 relative"}>
            <div
              className={
                "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
              }
            />
            <div
              className={
                "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-700 animate-pulse opacity-75"
              }
            />
          </div>
          <p className={"mt-4 text-gray-600"}>{"Loading products..."}</p>
        </div>
      </div>
    </div>
  ) : (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <main className="admin-main">
        <motion.div initial={"hidden"} animate={"visible"} variants={Lt} className={"mb-8"}>
          <h1 className={"text-3xl font-bold text-gray-900 mb-2"}>{"Products Management"}</h1>
          <p className={"text-gray-600"}>{"Manage and review all products uploaded by agents"}</p>
        </motion.div>
        {c && (
          <motion.div initial={"hidden"} animate={"visible"} variants={Lt} className={"mb-6"}>
            <div
              className={"bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md"}
              role={"alert"}
            >
              <p className={"font-medium"}>{"Error"}</p>
              <p>{c}</p>
            </div>
          </motion.div>
        )}
        <motion.div initial={"hidden"} animate={"visible"} variants={Lt} className={"mb-6"}>
          <div className={"bg-white p-4 rounded-xl shadow-sm"}>
            <div className={"flex flex-col md:flex-row justify-between gap-4"}>
              <div className={"w-full md:w-1/3"}>
                <div className={"relative"}>
                  <div
                    className={
                      "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    }
                  >
                    <SearchIcon className={"h-5 w-5 text-gray-400"} />
                  </div>
                  <input
                    type={"text"}
                    placeholder={"Search by title, agent, or description"}
                    className={
                      "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                    }
                    value={f}
                    onChange={(me) => h(me.target.value)}
                  />
                </div>
              </div>
              <div className={"flex flex-col sm:flex-row gap-4"}>
                <div className={"w-full sm:w-auto"}>
                  <div className={"relative"}>
                    <div
                      className={
                        "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      }
                    >
                      <FunnelIcon className={"h-5 w-5 text-gray-400"} />
                    </div>
                    <select
                      className={
                        "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                      }
                      value={p}
                      onChange={(me) => g(me.target.value)}
                    >
                      <option value={"all"}>{"All Categories"}</option>
                      {j.map((me, Ue) => (
                        <option key={Ue} value={me}>
                          {me}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className={"w-full sm:w-auto"}>
                  <div className={"relative"}>
                    <div
                      className={
                        "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      }
                    >
                      <ClockIcon className={"h-5 w-5 text-gray-400"} />
                    </div>
                    <select
                      className={
                        "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                      }
                      value={y}
                      onChange={(me) => v(me.target.value)}
                    >
                      <option value={"all"}>{"All Statuses"}</option>
                      {b.map((me, Ue) => (
                        <option key={Ue} value={me}>
                          {me}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <button
                  onClick={Bn}
                  className={
                    "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center"
                  }
                >
                  <XIcon className={"h-5 w-5 mr-2"} />
                  {"Clear Filters"}
                </button>
                <button
                  onClick={xe}
                  className={
                    "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                  }
                >
                  <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                  {"Refresh"}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={Lt}>
          {n.length > 0 ? (
            <jsxRuntime.Fragment>
              <div className={"bg-white rounded-2xl shadow-lg overflow-hidden"}>
                <div className={"px-6 py-4 border-b border-gray-200 bg-gray-50"}>
                  <div className={"flex justify-between items-center"}>
                    <div className={"text-sm text-gray-600"}>
                      {"Showing "}
                      {$t + 1}
                      {"-"}
                      {Math.min(on, n.length)}
                      {" of "}
                      {n.length}
                      {" products"}
                    </div>
                    <div className={"text-sm text-gray-600"}>
                      {"Page "}
                      {T}
                      {" of "}
                      {Xe}
                    </div>
                  </div>
                </div>
                <div className={"overflow-x-auto"}>
                  <table className={"min-w-full divide-y divide-gray-200"}>
                    <thead>
                      <tr>
                        <th
                          scope={"col"}
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Product"}
                        </th>
                        <th
                          scope={"col"}
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Agent"}
                        </th>
                        <th
                          scope={"col"}
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Category"}
                        </th>
                        <th
                          scope={"col"}
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Date"}
                        </th>
                        <th
                          scope={"col"}
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Price"}
                        </th>
                        <th
                          scope={"col"}
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Analysis Status"}
                        </th>
                        <th
                          scope={"col"}
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Actions"}
                        </th>
                      </tr>
                    </thead>
                    <tbody className={"bg-white divide-y divide-gray-200"}>
                      {On.map((me) => (
                        <tr
                          key={me.id || Math.random().toString()}
                          className={"hover:bg-gray-50 transition duration-150"}
                        >
                          <td className={"px-6 py-4 whitespace-nowrap"}>
                            <div
                              className={"flex items-center cursor-pointer hover:text-purple-600"}
                              onClick={() => oe(me)}
                            >
                              <div
                                className={
                                  "flex-shrink-0 h-10 w-10 bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg flex items-center justify-center text-white font-bold"
                                }
                              >
                                {me.title ? me.title.charAt(0).toUpperCase() : "P"}
                              </div>
                              <div className={"ml-4"}>
                                <div
                                  className={"text-sm font-medium text-gray-900 max-w-xs truncate"}
                                >
                                  {me.title || "Unnamed Product"}
                                </div>
                                <div className={"text-xs text-gray-500"}>
                                  {"ID: "}
                                  {me.id || "N/A"}
                                </div>
                                {me.language && (
                                  <div className={"text-xs text-purple-800 flex items-center mt-1"}>
                                    <GlobeIcon className={"w-3 h-3 mr-1"} />
                                    {me.language}
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className={"px-6 py-4 whitespace-nowrap"}>
                            <div className={"flex items-center"}>
                              <div
                                className={
                                  "flex-shrink-0 h-8 w-8 bg-gray-100 rounded-full flex items-center justify-center"
                                }
                              >
                                <UserIcon className={"h-4 w-4 text-gray-500"} />
                              </div>
                              <div className={"ml-3"}>
                                <div className={"text-sm text-gray-900"}>
                                  {me.agent_name || "Unknown"}
                                </div>
                                <div className={"text-xs text-gray-500"}>
                                  {me.uploaded_by || "N/A"}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className={"px-6 py-4 whitespace-nowrap"}>
                            <span
                              className={
                                "px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800"
                              }
                            >
                              {me.category || "Uncategorized"}
                            </span>
                          </td>
                          <td className={"px-6 py-4 whitespace-nowrap"}>
                            <div className={"text-sm text-gray-600 flex items-center"}>
                              <CalendarIcon className={"w-4 h-4 mr-1 text-gray-400"} />
                              {me.created_at ? new Date(me.created_at).toLocaleDateString() : "N/A"}
                            </div>
                          </td>
                          <td className={"px-6 py-4 whitespace-nowrap"}>
                            <div className={"text-sm font-medium text-gray-900"}>
                              {"₹"}
                              {typeof me.amount == "number" || typeof me.amount == "string"
                                ? parseFloat(me.amount).toFixed(2)
                                : "0.00"}
                            </div>
                          </td>
                          <td className={"px-6 py-4 whitespace-nowrap"}>
                            <span
                              className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full items-center
                              ${me.analysis_status === "completed" ? "bg-green-100 text-green-800" : me.analysis_status === "pending" ? "bg-yellow-100 text-yellow-800" : "bg-gray-100 text-gray-800"}`}
                            >
                              {me.analysis_status === "completed" && (
                                <CircleCheckBigIcon className={"w-3 h-3 mr-1"} />
                              )}
                              {me.analysis_status === "pending" && (
                                <ClockIcon className={"w-3 h-3 mr-1"} />
                              )}
                              {me.analysis_status
                                ? me.analysis_status.charAt(0).toUpperCase() +
                                  me.analysis_status.slice(1)
                                : "Not Analyzed"}
                            </span>
                          </td>
                          <td className={"px-6 py-4 whitespace-nowrap text-sm font-medium"}>
                            <div className={"flex space-x-2"}>
                              <button
                                onClick={() => oe(me)}
                                className={
                                  "p-2 bg-gray-50 text-gray-600 rounded-lg hover:bg-gray-100 transition-colors flex items-center"
                                }
                                title={"View Details"}
                              >
                                <EyeIcon className={"h-4 w-4"} />
                              </button>
                              <button
                                onClick={() => V(me)}
                                className={
                                  "p-2 bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-colors flex items-center"
                                }
                                title={"Edit Product"}
                              >
                                <SquarePenIcon className={"h-4 w-4"} />
                              </button>
                              <button
                                onClick={() => te(me)}
                                className={
                                  "p-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors flex items-center"
                                }
                                title={"Delete Product"}
                              >
                                <Trash2Icon className={"h-4 w-4"} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {Xe > 1 && (
                <div className={"bg-white px-4 py-3 border-t border-gray-200 rounded-b-2xl"}>
                  <div className={"flex items-center justify-between"}>
                    <div className={"flex-1 flex justify-between sm:hidden"}>
                      <button
                        onClick={Oa}
                        disabled={T === 1}
                        className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${T === 1 ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-700 bg-white hover:bg-gray-50"}`}
                      >
                        {"Previous"}
                      </button>
                      <button
                        onClick={Ur}
                        disabled={T === Xe}
                        className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${T === Xe ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-700 bg-white hover:bg-gray-50"}`}
                      >
                        {"Next"}
                      </button>
                    </div>
                    <div className={"hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"}>
                      <div>
                        <p className={"text-sm text-gray-700"}>
                          {"Showing"} <span className={"font-medium"}>{$t + 1}</span> {"to"}{" "}
                          <span className={"font-medium"}>{Math.min(on, n.length)}</span> {"of"}{" "}
                          <span className={"font-medium"}>{n.length}</span> {"results"}
                        </p>
                      </div>
                      <div>
                        <nav
                          className={"relative z-0 inline-flex rounded-md shadow-sm -space-x-px"}
                          aria-label={"Pagination"}
                        >
                          <button
                            onClick={Oa}
                            disabled={T === 1}
                            className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium ${T === 1 ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-500 bg-white hover:bg-gray-50"}`}
                          >
                            <ArrowRightIcon className={"h-5 w-5 transform rotate-180"} />
                          </button>
                          {T > 3 && (
                            <jsxRuntime.Fragment>
                              <button
                                onClick={() => ia(1)}
                                className={
                                  "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                                }
                              >
                                {"1"}
                              </button>
                              {T > 4 && (
                                <span
                                  className={
                                    "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"
                                  }
                                >
                                  {"..."}
                                </span>
                              )}
                            </jsxRuntime.Fragment>
                          )}
                          {gn().map((me) => (
                            <button
                              key={me}
                              onClick={() => ia(me)}
                              className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${me === T ? "z-10 bg-purple-50 border-purple-500 text-purple-600" : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"}`}
                            >
                              {me}
                            </button>
                          ))}
                          {T < Xe - 2 && (
                            <jsxRuntime.Fragment>
                              {T < Xe - 3 && (
                                <span
                                  className={
                                    "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"
                                  }
                                >
                                  {"..."}
                                </span>
                              )}
                              <button
                                onClick={() => ia(Xe)}
                                className={
                                  "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                                }
                              >
                                {Xe}
                              </button>
                            </jsxRuntime.Fragment>
                          )}
                          <button
                            onClick={Ur}
                            disabled={T === Xe}
                            className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium ${T === Xe ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-500 bg-white hover:bg-gray-50"}`}
                          >
                            <ArrowRightIcon className={"h-5 w-5"} />
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </jsxRuntime.Fragment>
          ) : (
            <div className={"bg-white rounded-2xl shadow-lg p-12 text-center"}>
              <div className={"flex flex-col items-center justify-center"}>
                <div
                  className={
                    "w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 mb-6"
                  }
                >
                  <PackageIcon className={"h-12 w-12"} />
                </div>
                <h3 className={"text-xl font-bold text-gray-800 mb-2"}>{"No Products Found"}</h3>
                <p className={"text-gray-500 mb-6"}>
                  {f || p !== "all" || y !== "all"
                    ? "No products match your filters. Try adjusting your search criteria."
                    : "There are no products in the system yet."}
                </p>
                <button
                  onClick={Bn}
                  className={
                    "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                  }
                >
                  <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                  {f || p !== "all" || y !== "all" ? "Clear Filters" : "Refresh"}
                </button>
              </div>
            </div>
          )}
        </motion.div>
      </main>
      {ee && R && (
        <div
          className={
            "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          }
        >
          <div
            className={"bg-white rounded-lg shadow-xl max-w-6xl w-full h-[700px]  overflow-hidden"}
          >
            <div className={"flex justify-between items-center p-6 border-b border-gray-200"}>
              <h3 className={"text-xl font-bold text-gray-900"}>{"Product Details"}</h3>
              <button onClick={() => re(false)} className={"text-gray-400 hover:text-gray-500"}>
                <XIcon className={"h-6 w-6"} />
              </button>
            </div>
            <div className={"p-6 overflow-y-auto max-h-135"}>
              <div className={"grid grid-cols-1 lg:grid-cols-3 gap-6"}>
                <div className={"lg:col-span-2 space-y-6"}>
                  <div className={"flex items-center space-x-4"}>
                    <div
                      className={
                        "flex-shrink-0 h-16 w-16 bg-gradient-to-br from-purple-500 to-purple-700 rounded-xl flex items-center justify-center text-white text-xl font-bold"
                      }
                    >
                      {R.title ? R.title.charAt(0).toUpperCase() : "P"}
                    </div>
                    <div>
                      <h4 className={"text-lg font-semibold text-gray-900"}>
                        {R.title || "Unnamed Product"}
                      </h4>
                      <p className={"text-sm text-gray-500"}>
                        {"ID: "}
                        {R.id}
                      </p>
                      {R.language && (
                        <div className={"flex items-center mt-1"}>
                          <GlobeIcon className={"w-4 h-4 mr-1 text-purple-700"} />
                          <span className={"text-sm text-purple-800"}>{R.language}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={"grid grid-cols-2 gap-4"}>
                    <div className={"bg-gray-50 p-3 rounded-lg"}>
                      <div className={"flex items-center space-x-2 mb-1"}>
                        <UserIcon className={"h-4 w-4 text-gray-500"} />
                        <span className={"text-xs font-medium text-gray-500 uppercase"}>
                          {"Agent"}
                        </span>
                      </div>
                      <p className={"text-sm font-medium text-gray-900"}>
                        {R.agent_name || "Unknown"}
                      </p>
                      {R.uploaded_by && (
                        <p className={"text-xs text-gray-500"}>
                          {"Uploaded by: "}
                          {R.uploaded_by}
                        </p>
                      )}
                    </div>
                    <div className={"bg-gray-50 p-3 rounded-lg"}>
                      <div className={"flex items-center space-x-2 mb-1"}>
                        <TagIcon className={"h-4 w-4 text-gray-500"} />
                        <span className={"text-xs font-medium text-gray-500 uppercase"}>
                          {"Category"}
                        </span>
                      </div>
                      <p className={"text-sm font-medium text-gray-900"}>
                        {R.category || "Uncategorized"}
                      </p>
                    </div>
                    <div className={"bg-gray-50 p-3 rounded-lg"}>
                      <div className={"flex items-center space-x-2 mb-1"}>
                        <DollarSignIcon className={"h-4 w-4 text-gray-500"} />
                        <span className={"text-xs font-medium text-gray-500 uppercase"}>
                          {"Price"}
                        </span>
                      </div>
                      <p className={"text-sm font-medium text-gray-900"}>
                        {"₹"}
                        {typeof R.amount == "number" || typeof R.amount == "string"
                          ? parseFloat(R.amount).toFixed(2)
                          : "0.00"}
                      </p>
                    </div>
                    <div className={"bg-gray-50 p-3 rounded-lg"}>
                      <div className={"flex items-center space-x-2 mb-1"}>
                        <CalendarIcon className={"h-4 w-4 text-gray-500"} />
                        <span className={"text-xs font-medium text-gray-500 uppercase"}>
                          {"Created"}
                        </span>
                      </div>
                      <p className={"text-sm font-medium text-gray-900"}>
                        {R.created_at ? new Date(R.created_at).toLocaleDateString() : "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className={"bg-purple-100 p-4 rounded-lg"}>
                    <div className={"flex items-center space-x-2 mb-3"}>
                      <UploadIcon className={"h-4 w-4 text-purple-700"} />
                      <span className={"text-sm font-medium text-gray-700"}>
                        {"Attached Files"}
                      </span>
                    </div>
                    <div className={"space-y-2"}>
                      {R.image && (
                        <div
                          className={
                            "flex items-center justify-between bg-white p-2 rounded border"
                          }
                        >
                          <div className={"flex items-center space-x-2"}>
                            <ImageIcon className={"w-4 h-4 text-purple-700"} />
                            <span className={"text-sm text-gray-700"}>{"Product Image"}</span>
                          </div>
                          <div className={"flex items-center space-x-2"}>
                            <span className={"text-xs text-gray-500"}>{bt(R.image)}</span>
                            <button
                              onClick={() => Ae(bt(R.image))}
                              className={
                                "p-1 bg-purple-200 text-purple-800 rounded hover:bg-purple-300 transition-colors"
                              }
                              title={"Download Image"}
                            >
                              <DownloadIcon className={"w-3 h-3"} />
                            </button>
                          </div>
                        </div>
                      )}
                      {R.project_file && (
                        <div
                          className={
                            "flex items-center justify-between bg-white p-2 rounded border"
                          }
                        >
                          <div className={"flex items-center space-x-2"}>
                            <CodeIcon className={"w-4 h-4 text-green-500"} />
                            <span className={"text-sm text-gray-700"}>{"Project File"}</span>
                          </div>
                          <div className={"flex items-center space-x-2"}>
                            <span className={"text-xs text-gray-500"}>{bt(R.project_file)}</span>
                            <button
                              onClick={() => tt(R.id, "project_file", bt(R.project_file))}
                              className={
                                "p-1 bg-green-100 text-green-600 rounded hover:bg-green-200 transition-colors"
                              }
                              title={"Download Project File"}
                            >
                              <DownloadIcon className={"w-3 h-3"} />
                            </button>
                          </div>
                        </div>
                      )}
                      {R.report_file && (
                        <div
                          className={
                            "flex items-center justify-between bg-white p-2 rounded border"
                          }
                        >
                          <div className={"flex items-center space-x-2"}>
                            <FileTextIcon className={"w-4 h-4 text-purple-500"} />
                            <span className={"text-sm text-gray-700"}>{"Report File"}</span>
                          </div>
                          <div className={"flex items-center space-x-2"}>
                            <span className={"text-xs text-gray-500"}>{bt(R.report_file)}</span>
                            <button
                              onClick={() => tt(R.id, "report_file", bt(R.report_file))}
                              className={
                                "p-1 bg-purple-100 text-purple-600 rounded hover:bg-purple-200 transition-colors"
                              }
                              title={"Download Report File"}
                            >
                              <DownloadIcon className={"w-3 h-3"} />
                            </button>
                          </div>
                        </div>
                      )}
                      {!R.image && !R.project_file && !R.report_file && (
                        <p className={"text-sm text-gray-500 text-center py-2"}>
                          {"No files attached"}
                        </p>
                      )}
                    </div>
                  </div>
                  {R.description && (
                    <div className={"bg-gray-50 p-4 rounded-lg"}>
                      <div className={"flex items-center space-x-2 mb-2"}>
                        <InfoIcon className={"h-4 w-4 text-gray-500"} />
                        <span className={"text-sm font-medium text-gray-700"}>{"Description"}</span>
                      </div>
                      <p className={"text-sm text-gray-700 whitespace-pre-wrap"}>{R.description}</p>
                    </div>
                  )}
                  {R.features && (
                    <div className={"bg-gray-50 p-4 rounded-lg"}>
                      <div className={"flex items-center space-x-2 mb-2"}>
                        <CircleCheckBigIcon className={"h-4 w-4 text-green-500"} />
                        <span className={"text-sm font-medium text-gray-700"}>{"Features"}</span>
                      </div>
                      <p className={"text-sm text-gray-700 whitespace-pre-wrap"}>{R.features}</p>
                    </div>
                  )}
                  {R.instructions && (
                    <div className={"bg-gray-50 p-4 rounded-lg"}>
                      <div className={"flex items-center space-x-2 mb-2"}>
                        <FileTextIcon className={"h-4 w-4 text-purple-700"} />
                        <span className={"text-sm font-medium text-gray-700"}>
                          {"Instructions"}
                        </span>
                      </div>
                      <p className={"text-sm text-gray-700 whitespace-pre-wrap"}>
                        {R.instructions}
                      </p>
                    </div>
                  )}
                  {R.demo && (
                    <div className={"bg-gray-50 p-4 rounded-lg"}>
                      <div className={"flex items-center space-x-2 mb-2"}>
                        <CircleHelpIcon className={"h-4 w-4 text-purple-500"} />
                        <span className={"text-sm font-medium text-gray-700"}>{"Demo"}</span>
                      </div>
                      {st(R.demo) ? (
                        <div className={"aspect-video w-full"}>
                          <iframe
                            className={"w-full h-full rounded-lg"}
                            src={Ve(R.demo)}
                            title={"Product Demo"}
                            frameBorder={"0"}
                            allow={
                              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            }
                            allowFullScreen={true}
                          />
                        </div>
                      ) : (
                        <p className={"text-sm text-gray-700 whitespace-pre-wrap"}>{R.demo}</p>
                      )}
                    </div>
                  )}
                  {R.faq && (
                    <div className={"bg-gray-50 p-4 rounded-lg"}>
                      <div className={"flex items-center space-x-2 mb-2"}>
                        <CircleHelpIcon className={"h-4 w-4 text-purple-500"} />
                        <span className={"text-sm font-medium text-gray-700"}>{"FAQ"}</span>
                      </div>
                      <p className={"text-sm text-gray-700 whitespace-pre-wrap"}>{R.faq}</p>
                    </div>
                  )}
                </div>
                <div className={"space-y-4"}>
                  <div className={"bg-purple-100 p-4 rounded-lg"}>
                    <h5 className={"text-lg font-semibold text-gray-900 mb-4"}>
                      {"Analysis Status & Result"}
                    </h5>
                    <div className={"mb-4"}>
                      <span className={"text-xs font-medium text-gray-500 uppercase block mb-2"}>
                        {"Current Status"}
                      </span>
                      <span
                        className={`px-3 py-1 inline-flex text-sm leading-5 font-semibold rounded-full items-center
                        ${R.analysis_status === "completed" ? "bg-green-100 text-green-800" : R.analysis_status === "pending" ? "bg-yellow-100 text-yellow-800" : "bg-gray-100 text-gray-800"}`}
                      >
                        {R.analysis_status === "completed" && (
                          <CircleCheckBigIcon className={"w-4 h-4 mr-2"} />
                        )}
                        {R.analysis_status === "pending" && (
                          <ClockIcon className={"w-4 h-4 mr-2"} />
                        )}
                        {R.analysis_status
                          ? R.analysis_status.charAt(0).toUpperCase() + R.analysis_status.slice(1)
                          : "Not Analyzed"}
                      </span>
                    </div>
                    {R.analysis_result && (
                      <div className={"mb-4"}>
                        <span className={"text-xs font-medium text-gray-500 uppercase block mb-2"}>
                          {"Analysis Result"}
                        </span>
                        <div
                          className={
                            "bg-white p-3 rounded border text-sm text-gray-700 max-h-32 overflow-y-auto"
                          }
                        >
                          {R.analysis_result}
                        </div>
                      </div>
                    )}
                    <div className={"mt-3"}>
                      <button
                        onClick={() => {
                          (re(false), de(R));
                        }}
                        className={
                          "w-full px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center justify-center"
                        }
                      >
                        <SquarePenIcon className={"h-4 w-4 mr-2"} />
                        {"Update Analysis Status"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={"px-6 py-4 bg-gray-50 border-t border-gray-200"}>
              <div className={"flex justify-end space-x-3"}>
                <button
                  onClick={() => re(false)}
                  className={
                    "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                  }
                >
                  {"Close"}
                </button>
                <button
                  onClick={() => {
                    (re(false), V(R));
                  }}
                  className={
                    "px-4 py-2 bg-purple-800 text-white rounded-lg hover:bg-purple-900 flex items-center"
                  }
                >
                  <SquarePenIcon className={"h-4 w-4 mr-2"} />
                  {"Edit Product"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {O && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <div className={"bg-white rounded-lg shadow-xl max-w-md w-full p-6"}>
            <h3 className={"text-lg font-bold text-gray-900 mb-4"}>{"Confirm Deletion"}</h3>
            <div className={"mb-6"}>
              <p className={"text-gray-600 mb-4"}>
                {
                  "Are you sure you want to delete the following product? This action cannot be undone."
                }
              </p>
              <div className={"bg-red-50 p-4 rounded-lg"}>
                <div className={"flex items-center mb-2"}>
                  <div
                    className={
                      "flex-shrink-0 h-8 w-8 bg-red-100 rounded-lg flex items-center justify-center text-red-500 mr-3"
                    }
                  >
                    <PackageIcon className={"h-4 w-4"} />
                  </div>
                  <div className={"font-medium text-red-800"}>
                    {C == null ? undefined : C.title}
                  </div>
                </div>
                <div className={"text-sm text-red-700 ml-11"}>
                  <p>
                    {"ID: "}
                    {C == null ? undefined : C.id}
                  </p>
                  <p>
                    {"Agent: "}
                    {C == null ? undefined : C.agent_name}
                  </p>
                </div>
              </div>
            </div>
            <div className={"flex justify-end space-x-3"}>
              <button
                onClick={() => _(false)}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                }
              >
                {"Cancel"}
              </button>
              <button
                onClick={ye}
                className={
                  "px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center"
                }
                disabled={a}
              >
                <Trash2Icon className={"h-5 w-5 mr-2"} />
                {a ? "Deleting..." : "Delete Product"}
              </button>
            </div>
          </div>
        </div>
      )}
      {$ && (
        <div
          className={
            "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          }
        >
          <div
            className={
              "bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-screen overflow-hidden flex flex-col"
            }
          >
            <div
              className={
                "flex justify-between items-center p-6 border-b border-gray-200 flex-shrink-0"
              }
            >
              <h3 className={"text-lg font-bold text-gray-900"}>{"Edit Product"}</h3>
              <button onClick={() => I(false)} className={"text-gray-400 hover:text-gray-500"}>
                <XIcon className={"h-6 w-6"} />
              </button>
            </div>
            <div className={"flex-1 overflow-y-auto p-6"}>
              <div className={"grid grid-cols-1 lg:grid-cols-2 gap-6"}>
                <div className={"space-y-4"}>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                      {"Product Title *"}
                    </label>
                    <input
                      type={"text"}
                      name={"title"}
                      value={z.title}
                      onChange={ce}
                      className={
                        "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                      }
                      placeholder={"Enter product title"}
                    />
                  </div>
                  <div className={"grid grid-cols-2 gap-4"}>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                        {"Category"}
                      </label>
                      <select
                        name={"category"}
                        value={z.category}
                        onChange={ce}
                        className={
                          "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                        }
                      >
                        <option value={""}>{"Select a category"}</option>
                        {j.map((me, Ue) => (
                          <option key={Ue} value={me}>
                            {me}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                        {"Price (₹)"}
                      </label>
                      <input
                        type={"number"}
                        name={"amount"}
                        value={z.amount}
                        onChange={ce}
                        className={
                          "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                        }
                        placeholder={"0.00"}
                        step={"0.01"}
                        min={"0"}
                      />
                    </div>
                  </div>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                      {"Language"}
                    </label>
                    <input
                      type={"text"}
                      name={"language"}
                      value={z.language}
                      onChange={ce}
                      className={
                        "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                      }
                      placeholder={"e.g., Python, JavaScript, etc."}
                    />
                  </div>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                      {"Description"}
                    </label>
                    <textarea
                      name={"description"}
                      value={z.description}
                      onChange={ce}
                      rows={"4"}
                      className={
                        "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                      }
                      placeholder={"Enter product description"}
                    />
                  </div>
                </div>
                <div className={"space-y-4"}>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                      {"Features"}
                    </label>
                    <textarea
                      name={"features"}
                      value={z.features}
                      onChange={ce}
                      rows={"4"}
                      className={
                        "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                      }
                      placeholder={"List key features of the product"}
                    />
                  </div>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                      {"Instructions"}
                    </label>
                    <textarea
                      name={"instructions"}
                      value={z.instructions}
                      onChange={ce}
                      rows={"4"}
                      className={
                        "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                      }
                      placeholder={"Enter usage instructions"}
                    />
                  </div>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                      {"FAQ"}
                    </label>
                    <textarea
                      name={"faq"}
                      value={z.faq}
                      onChange={ce}
                      rows={"4"}
                      className={
                        "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                      }
                      placeholder={"Frequently asked questions and answers"}
                    />
                  </div>
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                      {"Demo"}
                    </label>
                    <textarea
                      name={"demo"}
                      value={z.demo}
                      onChange={ce}
                      rows={"3"}
                      className={
                        "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                      }
                      placeholder={"Enter YouTube demo video URL or demo description"}
                    />
                    {z.demo && st(z.demo) && (
                      <div className={"mt-2 p-2 bg-green-50 border border-green-200 rounded-lg"}>
                        <div className={"flex items-center space-x-2"}>
                          <svg
                            className={"h-4 w-4 text-green-500"}
                            fill={"currentColor"}
                            viewBox={"0 0 24 24"}
                          >
                            <path
                              d={
                                "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                              }
                            />
                          </svg>
                          <span className={"text-sm text-green-700"}>
                            {"YouTube video will be embedded"}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={"px-6 py-4 bg-gray-50 border-t border-gray-200 flex-shrink-0"}>
              <div className={"flex justify-end space-x-3"}>
                <button
                  onClick={() => I(false)}
                  className={
                    "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                  }
                  disabled={a}
                >
                  {"Cancel"}
                </button>
                <button
                  onClick={$e}
                  className={
                    "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center transition-colors"
                  }
                  disabled={a}
                >
                  {a ? (
                    <jsxRuntime.Fragment>
                      <RefreshCwIcon className={"h-4 w-4 mr-2 animate-spin"} />
                      {"Saving..."}
                    </jsxRuntime.Fragment>
                  ) : (
                    <jsxRuntime.Fragment>
                      <SaveIcon className={"h-4 w-4 mr-2"} />
                      {"Save Changes"}
                    </jsxRuntime.Fragment>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {K && (
        <div
          className={
            "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          }
        >
          <div
            className={"bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-96 overflow-hidden"}
          >
            <div className={"flex justify-between items-center p-6 border-b border-gray-200"}>
              <h3 className={"text-lg font-bold text-gray-900"}>{"Update Analysis Status"}</h3>
              <button onClick={() => Q(false)} className={"text-gray-400 hover:text-gray-500"}>
                <XIcon className={"h-6 w-6"} />
              </button>
            </div>
            <div className={"p-6 overflow-y-auto max-h-80"}>
              <div className={"mb-6 bg-gray-50 p-4 rounded-lg"}>
                <div className={"flex items-center"}>
                  <div
                    className={
                      "flex-shrink-0 h-12 w-12 bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg flex items-center justify-center text-white font-bold"
                    }
                  >
                    {ne != null && ne.title ? ne.title.charAt(0).toUpperCase() : "P"}
                  </div>
                  <div className={"ml-4"}>
                    <div className={"text-lg font-medium text-gray-900"}>
                      {(ne == null ? undefined : ne.title) || "Unnamed Product"}
                    </div>
                    <div className={"flex space-x-4 text-sm text-gray-500"}>
                      <span>
                        {"ID: "}
                        {(ne == null ? undefined : ne.id) || "N/A"}
                      </span>
                      <span>
                        {"Agent: "}
                        {(ne == null ? undefined : ne.agent_name) || "Unknown"}
                      </span>
                      <span>
                        {"Category: "}
                        {(ne == null ? undefined : ne.category) || "Uncategorized"}
                      </span>
                    </div>
                    <div className={"mt-1 text-sm text-gray-600"}>
                      {"Price: ₹"}
                      {typeof (ne == null ? undefined : ne.amount) == "number" ||
                      typeof (ne == null ? undefined : ne.amount) == "string"
                        ? parseFloat(ne.amount).toFixed(2)
                        : "0.00"}
                    </div>
                  </div>
                </div>
              </div>
              <ProductAnalysisForm product={ne} onUpdate={_n} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export { ProductsPage };
